import React from "react"
import { SectionWrapper } from "../landing-section/landing-section.styles"
import styled from "styled-components"
import LogoFooter from "../../images/quick-fin-white.svg"

export const Separator = styled.div`
  width: 100%;
  height: 6px;
  background: linear-gradient(270deg, rgb(0, 198, 199) 0%, rgb(0, 70, 96) 100%);
`

export const StyledLandingFooter = styled.footer`
  background-color: #282828;
`

export const LandingFooterWrapper = styled(SectionWrapper)`
  padding: 30px;

  @media screen and (min-width: 1100px) {
    padding: 20px 0;
  }
`

export const FooterCopyright = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 1100px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  img {
    width: 90px;
    margin-bottom: 20px;

    @media screen and (min-width: 1100px) {
      width: 118px;
      margin-bottom: 0;
    }
  }

  span {
    color: #fff;
    font-size: 14px;

    @media screen and (min-width: 1100px) {
      font-size: 20px;
    }
  }
`

export default function LandingFooter() {
  return (
    <>
      <Separator />
      <StyledLandingFooter>
        <LandingFooterWrapper>
          <FooterCopyright>
            <img src={LogoFooter} alt="Quickfin" />
            <span>© BTG Pactual 2020. Todos os direitos reservados</span>
          </FooterCopyright>
        </LandingFooterWrapper>
      </StyledLandingFooter>
    </>
  )
}
